<template>
  <div>
    <label v-if="title">{{ title }}</label>
    <ul v-if="items.length" :class="`status ${readonly ? 'disabled' : ''}`">
      <li v-for="(item, key) in items" :key="key">
        <div>
          <input
            :readonly="readonly"
            @change="change"
            :id="name + 'item-' + item.id"
            :value="item.id"
            :name="name"
            :checked="value == item.id"
            type="radio"
          />
          <label :for="name + 'item-' + item.id">{{ item.title }}</label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "order-status",
  props: ["name", "items", "title", "value", "readonly"],
  methods: {
    change(e) {
      if (this.readonly) {
        alert("Нельзя изменить тип вопроса");

        return true;
      }
      this.$emit("input", e.target.value);
    },
  },
};
</script>

